export const generatePaginationLinks = (pagination) => {
    if(!pagination){
        return []
    }
    let links = [];
    for (let page = 1; page <= pagination.last_page; page++) {
        links.push({
            url: pagination.first_page_url.replace('page=1', `page=${page}`),
            label: page.toString(),
            active: page === pagination.current_page
        });
    }
    return links;
}